import type { ContractViewModel } from '@trinnvis/dabih-api-client';
import { sortBy } from 'lodash';

export function _filterByPartnerId(list?: ContractViewModel[], uuid?: string): ContractViewModel[] {
  if (list === undefined || uuid === undefined) {
    return [];
  }

  return sortBy(
    list.filter(function (item) {
      if (item.partners === undefined) {
        return false;
      }
      return item.partners.includes(uuid);
    }),
    (e) => e.name.toLowerCase(),
  );
}
